import {Component, inject, signal} from '@angular/core';
import {ChatMessage, ChatService} from "../services/chat.service";
import {finalize} from "rxjs";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-app-statystics',
  imports: [
    NgClass
  ],
  templateUrl: './app-statystics.component.html',
  styleUrl: './app-statystics.component.css'
})
export class AppStatysticsComponent {
  private chatService = inject(ChatService);
  showAiAssistent = signal<boolean>(false);

  messages: ChatMessage[] = [];
  // 👇 Define userInput as a writable signal
  userInput = signal<string>('');
  isLoading: boolean = false;

  constructor() {
    this.messages.push({
      author: 'bot',
      text: 'Hello! Ask me about your Google Analytics data. For example: "How many active users did we have last week?"'
    });
  }

  sendMessage(): void {
    // 👇 Get the signal's value by calling it like a function
    const currentQuery = this.userInput().trim();

    if (!currentQuery || this.isLoading) {
      return;
    }

    const userMessage: ChatMessage = { author: 'user', text: currentQuery };
    this.messages.push(userMessage);

    // 👇 Reset the signal's value using .set()
    this.userInput.set('');
    this.isLoading = true;

    this.chatService.sendMessage(currentQuery)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (response) => {
          const botMessage: ChatMessage = { author: 'bot', text: response.answer };
          this.messages.push(botMessage);
        },
        error: (err) => {
          const errorMessage: ChatMessage = { author: 'bot', text: `Sorry, something went wrong: ${err.message}` };
          this.messages.push(errorMessage);
        }
      });
  }

  toggleAiAssistent() {
this.showAiAssistent.set(!this.showAiAssistent())
  }
}
